import type { Locale } from "@/shared/utils";
import type { DailyStatusCode } from "../types";

export function getDailyStatusCodeLabel(code: DailyStatusCode, locale: Locale): string {
  const labels: Record<Locale, Record<DailyStatusCode, string>> = {
    ru: {
      "1": "1ч - Работа",
      "2": "2ч - Работа",
      "3": "3ч - Работа",
      "4": "4ч - Полдня",
      "5": "5ч - Работа",
      "6": "6ч - Работа",
      "7": "7ч - Работа",
      "8": "8ч - Работа",
      В: "В - Выходной",
      О: "О - Отпуск",
      Б: "Б - Больничный",
      А: "А - Без содержания",
      К: "К - Командировка",
      Р: "Р - Декрет",
      П: "П - Прогул",
      "": "Не трудоустроен",
    },
    en: {
      "1": "1h - Work",
      "2": "2h - Work",
      "3": "3h - Work",
      "4": "4h - Half day",
      "5": "5h - Work",
      "6": "6h - Work",
      "7": "7h - Work",
      "8": "8h - Work",
      В: "W - Weekend",
      О: "L - Leave",
      Б: "S - Sick",
      А: "U - Unpaid",
      К: "T - Trip",
      Р: "M - Maternity",
      П: "A - Absence",
      "": "Not employed",
    },
    kk: {
      "1": "1сағ - Жұмыс",
      "2": "2сағ - Жұмыс",
      "3": "3сағ - Жұмыс",
      "4": "4сағ - Жарты күн",
      "5": "5сағ - Жұмыс",
      "6": "6сағ - Жұмыс",
      "7": "7сағ - Жұмыс",
      "8": "8сағ - Жұмыс",
      В: "В - Демалыс",
      О: "О - Еңбек демалысы",
      Б: "Б - Ауру",
      А: "А - Ақысыз",
      К: "К - Кәсіби сапар",
      Р: "Р - Аналық",
      П: "П - Қатыспау",
      "": "Жұмыста емес",
    },
  };

  return labels[locale]?.[code] || code;
}

export function getDaysInMonth(year: number, month: number): number {
  return new Date(year, month, 0).getDate();
}
